import I18n from '@utils/i18n.utils';
import {Pagination} from '@store/common/pagination.model';
import {SelectItem} from '@components/inputs/select/Select.component';

export enum InterfaceEntityTypeEnum {
  CONTRACT = 'CONTRACT',
  SERVICE = 'SERVICE',
  ORGANISATION = 'ORGANISATION',
  ORGANISATION_UNIT = 'ORGANISATION_UNIT',
  SUPPLIER_ORGANISATION_UNIT = 'SUPPLIER_ORGANISATION_UNIT',
  WASTE = 'WASTE',
  CONTAINER = 'CONTAINER',
  SERVICE_KIND = 'SERVICE_KIND',
}

export namespace InterfaceEntityTypeEnum {
  export const selectItems = () => [
    { label: I18n.t('global.interfaceEntityType.organisation'), value: InterfaceEntityTypeEnum.ORGANISATION },
    { label: I18n.t('global.interfaceEntityType.organisationUnit'), value: InterfaceEntityTypeEnum.ORGANISATION_UNIT },
    { label: I18n.t('global.interfaceEntityType.supplierOrganisationUnit'), value: InterfaceEntityTypeEnum.SUPPLIER_ORGANISATION_UNIT },
    { label: I18n.t('global.interfaceEntityType.waste'), value: InterfaceEntityTypeEnum.WASTE },
    { label: I18n.t('global.interfaceEntityType.container'), value: InterfaceEntityTypeEnum.CONTAINER },
    { label: I18n.t('global.interfaceEntityType.serviceKind'), value: InterfaceEntityTypeEnum.SERVICE_KIND },
    { label: I18n.t('global.interfaceEntityType.contract'), value: InterfaceEntityTypeEnum.CONTRACT },
    { label: I18n.t('global.interfaceEntityType.service'), value: InterfaceEntityTypeEnum.SERVICE },
  ].sort((a, b) => a.label.localeCompare(b.label));
}

export interface InterfaceEntityPagination extends Pagination {
  data: InterfaceEntity[];
}

export interface InterfaceFilters {
  entityType: InterfaceEntityTypeEnum;
  search: string;
}

export interface InterfaceEntity {

  entityType?: InterfaceEntityTypeEnum;
  entityTypeItem?: SelectItem;
  entityItem?: SelectItem;

  id: number;
  datahubId?: string;
  metawasteTableName?: string;
  name?: string;
  datahubTableName?: string;
  datahubOrigin?: 'NESSY' | 'TANGBOM';
}
